<p-select
  [appendTo]="'body'"
  (onChange)="onDirectionChange($event)"
  [options]="directionList"
  [(ngModel)]="direction"
  filterBy="label, value"
  [disabled]="disabled()"
  placeholder="All Directions"
>
  <ng-template #selectedItem>
    @if (direction) {
      <p-chip
        [label]="getDirectionLabel(direction)"
        [removable]="showClear() && !disabled()"
        removeIcon="pi pi-times"
        (onRemove)="clearDirection()"
      />
    }
  </ng-template>
</p-select>
